import { IonButtons } from '@ionic/react';
import DynamicButton from 'components/buttons/DynamicButton';
import { Trans } from 'react-i18next';

// The ToggleVideoButton component is used in the TopBar components to
// switch between the video and the 3D model views

// interface ToggleVideoButtonProps {
//   hasVideo: boolean;
//   videoActive: boolean;
//   onVideoToggle: () => void;
// }
// const ToggleVideoButton = (props: ToggleVideoButtonProps) => {
//   const { hasVideo, videoActive, onVideoToggle } = props;
//   return (
//     <IonButton
//       onClick={onVideoToggle}
//       fill="solid"
//       color="primary"
//       disabled={!hasVideo}
//     >
//       <IonIcon
//         src={`/assets/icons/${videoActive ? '3d_View.svg' : 'Video_View.svg'}`}
//         icon={videoActive ? discOutline : filmOutline}
//         color="secondary"
//       />
//     </IonButton>
//   );
// };

// The TopBar component is used in the RunPage component to display the common
// options a user has when viewing a trick: back, menu, and video toggle
interface TopBarProps {
  hasVideo: boolean;
  videoActive: boolean;
  onBack: (ev: React.MouseEvent<HTMLIonButtonElement, MouseEvent>) => void;
  onViewFigureInfo: (
    ev: React.MouseEvent<HTMLIonButtonElement, MouseEvent>
  ) => void;
  onVideoToggle: () => void;
  showUfoScore: boolean;
  onToggleUfoScore: () => void;
  onShowMenu: (ev: React.MouseEvent<HTMLIonButtonElement, MouseEvent>) => void;
  onDelete?: (ev: React.MouseEvent<HTMLIonButtonElement, MouseEvent>) => void;
  onShare?: (ev: React.MouseEvent<HTMLIonButtonElement, MouseEvent>) => void;
  onVideoRender?: (ev: React.MouseEvent<HTMLIonButtonElement, MouseEvent>) => void;
  isPublic?: boolean; // hinzugefügt
  isFriend?: boolean; // hinzugefügt
}
export const TopBar = (props: TopBarProps) => {
  const {
    onBack,
    onViewFigureInfo,
    videoActive,
    showUfoScore,
    onToggleUfoScore,
    onShowMenu,
    onDelete,
    onShare,
    onVideoRender,
  } = props;
  // Wrapper functions that create proper events
  const handleBack = () => {
    const mockEvent = {
      preventDefault: () => {},
    } as React.MouseEvent<HTMLIonButtonElement, MouseEvent>;
    onBack(mockEvent);
  };

  const handleDelete = () => {
    const mockEvent = {
      preventDefault: () => {},
    } as React.MouseEvent<HTMLIonButtonElement, MouseEvent>;
    if (onDelete) {
      onDelete(mockEvent);
    } else {
      // Fallback to back if no delete handler provided
      onBack(mockEvent);
    }
  };

  const handleViewFigureInfo = () => {
    const mockEvent = {
      preventDefault: () => {},
    } as React.MouseEvent<HTMLIonButtonElement, MouseEvent>;
    onViewFigureInfo(mockEvent);
  };

  const handleShowMenu = () => {
    const mockEvent = {
      preventDefault: () => {},
    } as React.MouseEvent<HTMLIonButtonElement, MouseEvent>;
    onShowMenu(mockEvent);
  };

  const handleShareAction = () => {
    const mockEvent = {
      preventDefault: () => {},
    } as React.MouseEvent<HTMLIonButtonElement, MouseEvent>;
    
    if (videoActive && onVideoRender) {
      onVideoRender(mockEvent);
    } else if (!videoActive && onShare) {
      onShare(mockEvent);
    } else {
      // Fallback to old behavior if handlers not provided
      onShowMenu(mockEvent);
    }
  };

  return (
    <div className="navbar canvas-overlay notchSafe">
      <IonButtons slot="start">
        <DynamicButton
          iconName={showUfoScore ? 'TelemetrieDownIcon' : 'JudgeUpIcon'}
          text=""
          buttonType="icon"
          fill="clear"
          size="xlarge"
          onClick={onToggleUfoScore}
        />
      </IonButtons>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          left: '50%',
          // marginLeft: 'auto',
        }}
      >
        <IonButtons>
          <DynamicButton
            iconName={videoActive ? "ShareVideoUpIcon" : "ShareUpIcon"}
            text={<Trans i18nKey="Menu" />}
            buttonType="icon-full"
            fill="clear"
            size="xlarge"
            onClick={handleShareAction}
          />
        </IonButtons>

        <IonButtons>
          <DynamicButton
            iconName="InfoUpIcon"
            text={<Trans i18nKey="Weiter" />}
            buttonType="icon-full"
            fill="clear"
            size="xlarge"
            onClick={handleViewFigureInfo}
          />
        </IonButtons>

        <IonButtons>
          {props.onDelete && !props.isPublic && !props.isFriend && (
            <DynamicButton
              iconName="DeleteUpIcon"
              text=""
              buttonType="icon-full"
              fill="clear"
              size="xlarge"
              onClick={handleDelete}
            />
          )}
        </IonButtons>
      </div>

      <IonButtons slot="end">
        <DynamicButton
          iconName="CancelUpIcon"
          text=""
          buttonType="icon-full"
          fill="clear"
          size="xlarge"
          onClick={handleBack}
        />
      </IonButtons>
    </div>
  );
};

// The PreviewTopBar component is used in the RunPage component to display
// a trick that has not been saved yet (i.e. a preview or a shared trick).
// It has the same look as the TopBar component, but with different options
// for discarding and opening trick info and toggeling the video
interface PreviewTopBarProps {
  hasVideo: boolean;
  videoActive: boolean;
  onDiscard: (ev: React.MouseEvent<HTMLIonButtonElement, MouseEvent>) => void;
  onViewFigureInfo: (
    ev: React.MouseEvent<HTMLIonButtonElement, MouseEvent>
  ) => void;
  onSave: (ev: React.MouseEvent<HTMLIonButtonElement, MouseEvent>) => void;
  onVideoToggle: () => void;
  showUfoScore: boolean;
  onToggleUfoScore: () => void;
}
export const PreviewTopBar = (props: PreviewTopBarProps) => {
  const {
    onDiscard,
    onViewFigureInfo,
    onSave,
    showUfoScore,
    onToggleUfoScore,
  } = props;
  // Wrapper functions that create proper events
  const handleDiscard = () => {
    const mockEvent = {
      preventDefault: () => {},
    } as React.MouseEvent<HTMLIonButtonElement, MouseEvent>;
    onDiscard(mockEvent);
  };

  const handleViewFigureInfo = () => {
    const mockEvent = {
      preventDefault: () => {},
    } as React.MouseEvent<HTMLIonButtonElement, MouseEvent>;
    onViewFigureInfo(mockEvent);
  };

  const handleSave = () => {
    const mockEvent = {
      preventDefault: () => {},
    } as React.MouseEvent<HTMLIonButtonElement, MouseEvent>;
    onSave(mockEvent);
  };

  return (
    <div className="navbar canvas-overlay notchSafe">
      <IonButtons>
        <DynamicButton
          iconName="OKUpIcon"
          text={<Trans i18nKey="Weiter" />}
          buttonType="icon-full"
          fill="clear"
          size="xlarge"
          onClick={handleSave}
        />
      </IonButtons>
      <IonButtons>
        <DynamicButton
          iconName={showUfoScore ? 'TelemetrieDownIcon' : 'JudgeUpIcon'}
          text=""
          buttonType="icon-full"
          fill="clear"
          size="xlarge"
          onClick={onToggleUfoScore}
        />
      </IonButtons>
      <IonButtons>
        <DynamicButton
          iconName="InfoUpIcon"
          text={<Trans i18nKey="Weiter" />}
          buttonType="icon"
          fill="clear"
          size="xlarge"
          onClick={handleViewFigureInfo}
        />
      </IonButtons>
      <IonButtons>
        <DynamicButton
          iconName="CancelUpIcon"
          text={<Trans i18nKey="Weiter" />}
          buttonType="icon-full"
          fill="clear"
          size="xlarge"
          onClick={handleDiscard}
        />
      </IonButtons>
    </div>
  );
};
